import component from './context-wrapper';
import './context-wrapper.sass'

export default component;